import React from "react";
import ReactDOM from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";
import configureAppStore from "./store/configureStore";
import "./index.css";
import AppRoute from "./app";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <ReduxProvider store={configureAppStore()}>
    <AppRoute />
  </ReduxProvider>
);